import React, { useEffect, useRef, useState } from 'react';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Question } from '../../../components/questionnaires/questions/Question';
import { StartSection } from '../../../components/questionnaires/StartSection';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { questionnaireItemsActions } from '../../../../core/questionnaire-items/actions';
import ReactGA from 'react-ga';
import { trackingActions } from '../../../../core/tracking';
import { QuestionnaireReview } from './QuestionnaireReview';

const animationClass = {
    appearActive: 'animate__animated animate__slideInRight',
    enter: 'animate__animated',
    enterActive: 'animate__animated animate__slideInRight',
    exit: 'animate__animated',
    exitActive: 'animate__animated animate__slideOutLeft position-absolute top-0 left-0',
}

export const QuestionnairePage = (params) => {
    const { id } = useParams();
    const nodeRef = useRef(null);
    const showAnimation = params.animation !== undefined ? params.animation : true;
    const dispatch = useDispatch();
    const questionnaire_list = useSelector(state => state.questionnaire_list);
    const [currentSection, setCurrentSection] = useState('start');
    const [lastQuestionnaire, setLastQuestionnaire] = useState();

    useEffect(() => {
        if(id == questionnaire_list?.data?.questionnaire?.id){
            if(questionnaire_list.data?.questionnaire?.completion == 100 && currentSection !== 'finish') {
                setCurrentSection('finish')
            }
        }
    }, [questionnaire_list?.data?.questionnaire, id, currentSection])

    useEffect(() => {
        dispatch(questionnaireItemsActions.loadQuestionnaireItems(Number(id !== undefined ? id : params.id)));
    }, []);

    useEffect(() => {
        setLastQuestionnaire(questionnaire_list.data?.questionnaire ? questionnaire_list.data?.questionnaire : lastQuestionnaire)
    }, [questionnaire_list, lastQuestionnaire]);

    useEffect(() => {
        if(currentSection === 'finish' && !questionnaire_list.isPending && questionnaire_list.data?.questionnaire?.completion != 100) {
            ReactGA.event({
                category: 'Questionnaires',
                action: `${questionnaire_list.data?.questionnaire?.name} completed`
            })
            dispatch(trackingActions.saveTrackingEvent({category: 'Questionnaires', action: `${questionnaire_list.data.questionnaire?.code || questionnaire_list.data.questionnaire?.name} completed`}))
        }
    }, [currentSection, questionnaire_list.isPending]);

    const handleNextSection = (section) => {
        setCurrentSection(section)
    }


    const navigationSection = () => {
        switch (currentSection) {
            case "start":
                return <StartSection
                    questionnaire_list={questionnaire_list}
                    typeQuestionnaire={questionnaire_list.data.questionnaire && questionnaire_list.data.questionnaire.code}
                    text={questionnaire_list.data.questionnaire && questionnaire_list.data.questionnaire.detail}
                    handleNextSection={handleNextSection}
                    icon={questionnaire_list.data.questionnaire && questionnaire_list.data.questionnaire.icon} />
            case "question":
                return <Question handleNextSection={handleNextSection} />
            case "finish":
                return <QuestionnaireReview />
            default:
                return <StartSection
                    questionnaire_list={questionnaire_list}
                    typeQuestionnaire={questionnaire_list.data.questionnaire && questionnaire_list.data.questionnaire.code}
                    text={questionnaire_list.data.questionnaire && questionnaire_list.data.questionnaire.detail}
                    handleNextSection={handleNextSection}
                    icon={questionnaire_list.data.questionnaire && questionnaire_list.data.questionnaire.icon} />
        }
    }

    return (
        <>
            <div className="container-fluid">
                <div className='view overflow-hidden questionnaire-content h-100 position-relative'>
                {parseInt(id) === questionnaire_list?.data?.questionnaire?.id && 
                    <TransitionGroup component={null}>
                        <CSSTransition nodeRef={nodeRef} classNames={showAnimation && animationClass} timeout={{ enter: 1000, exit: 1000 }} key={`${currentSection}`} appear>
                            <div ref={nodeRef} className="w-100 h-100">
                                {navigationSection()}
                            </div>
                        </CSSTransition>
                    </TransitionGroup>
                }
                </div>
            </div>
        </>
    )
}
